export default __webpack_public_path__ + "static/media/sticky.ebef6a97.jpg";